import { createSlice } from '@reduxjs/toolkit';
import { LANGUAGE_LIST, LANGUAGE_MAP } from '../../config/dataConfig/FJTextBasedEditingData.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJTextContent from '../../core/textBasedEditing/FJTextContent.js';
const language = FJLocalStore.getLanguageFromUrl();

const FJTextBasedEditing = createSlice({
    name: 'textBasedEditing',
    initialState: {
        editTextPreviewId: 'text-based-edit-content',
        originalResourceData: {
            type: 'video', // video | audio
            url: '', // 原始资源的url,
            id: '',
            duration: 0,
        },
        isLoadingResource: false,
        languageList: LANGUAGE_LIST,
        selectedLanguage: LANGUAGE_MAP[language] || 'english',
        activePanelName: 'default', // default | edit | transcribing
        currentMatchIndex: -1, // 当前选中的匹配项索引
        matchIndexList: [], // 搜索匹配的索引列表
        isHideTextForDelete: false,
        highLightFreeNum: 2,
        historyData: null,
        searchText: '',
    },
    reducers: {
        setSearchTextAction: (state, action) => {
            state.searchText = action.payload;
        },
        setOriginalResourceDataAction: (state, action) => {
            state.originalResourceData = action.payload;
        },
        setIsLoadingResourceAction: (state, action) => {
            state.isLoadingResource = action.payload;
        },
        setSelectedLanguageAction: (state, action) => {
            state.selectedLanguage = action.payload;
        },
        setActivePanelName: (state, action) => {
            state.activePanelName = action.payload;
            if (state.activePanelName === 'default' && FJTextContent.getAllTextList().length > 0) {
                const historyData = FJTextContent.toJson();
                state.historyData = historyData;
            }
        },
        setHistoryData: (state, action) => {
            state.historyData = action.payload;
        },
        setCurrentMatchIndex: (state, action) => {
            state.currentMatchIndex = action.payload;
        },
        setMatchIndexList: (state, action) => {
            state.matchIndexList = action.payload;
        },
        setIsHideTextForDelete: (state, action) => {
            state.isHideTextForDelete = action.payload;
        },
        setHighLightFreeNum: (state, action) => {
            state.highLightFreeNum = action.payload;
        },
    },
});

export const {
    setSearchTextAction,
    setOriginalResourceDataAction,
    setIsLoadingResourceAction,
    setSelectedLanguageAction,
    setActivePanelName,
    setCurrentMatchIndex,
    setMatchIndexList,
    setIsHideTextForDelete,
    setHighLightFreeNum,
    setHistoryData,
} = FJTextBasedEditing.actions;
export default FJTextBasedEditing.reducer;
